import React from 'react';
import { useTranslation } from 'react-i18next';
import './ReportFooter.css';

/**
 * Footer-Komponente für Report-Seiten
 * Zeigt Datum, Benutzer/Gerät und Seitennummer an
 */
function ReportFooter({ pageNumber, totalPages, userEmail, userDeviceName }) {
  const { t } = useTranslation();
  const now = new Date();
  const dateStr = now.toLocaleDateString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });

  return (
    <div className="report-page-footer-oneline">
      <span>{dateStr}</span>
      <span>{userEmail || t('report.not_specified')} | {userDeviceName || t('report.unknown')}</span>
      <span>{t('report.page_of', { page: pageNumber, total: totalPages })}</span>
    </div>
  );
}

export default ReportFooter;
